import axios from "axios";
import https from "https";

export const Api = axios.create({
  baseURL: "https://api.farmine.land/api/v1",
  httpsAgent: new https.Agent({ rejectUnauthorized: false }),
});
